import type { MusicService } from '../types';
import { ImporterID, MusicAPIIntegrationID } from '../ids';
import { musicServiceMessages } from '../messages';

export const deezer: MusicService = {
  id: 'deezer',
  name: 'Deezer',
  shortName: 'Deezer',
  isSupported: true,
  isComingSoon: false,
  areStatsSupported: false,
  areStatsComingSoon: false,
  isAlbumTransferSupported: true,
  color: {
    primary: '#23232D',
    label: '#953ff6',
    background: '#7a6e8c',
    text: '#6b42b4',
  },
  importerID: ImporterID.Deezer,
  musicAPIID: MusicAPIIntegrationID.Deezer,
  linkType: 'deezer',
  limits: {
    tracksPerPlaylist: 2000,
  },
  assets: {
    logo: { light: 'deezer-light.svg', dark: 'deezer-dark.svg' },
    logoPadding: { light: 'deezer-light-padding.svg', dark: 'deezer-dark-padding.svg' },
    logoColor: { light: 'deezer-color-light.svg', dark: 'deezer-color-dark.svg' },
    logoColorPadding: {
      light: 'deezer-color-light-padding.svg',
      dark: 'deezer-color-dark-padding.svg',
    },
    logoOnBackground: 'deezer-color-dark.svg',
  },
  whatIsDescription: musicServiceMessages.deezerWhatIs,
  authenticatedApiCapabilities: {
    doesSupportUpdatingPlaylists: true,
    doesSupportRemovingPlaylists: true,
    doesSupportRemovingTracks: true,
    doesSupportMovingTracks: true,
    doesSupportAddingTracksToLibrary: true,
    doesSupportRemovingTracksFromLibrary: true,
    doesSupportFetchingLibraryAlbums: true,
    doesSupportFetchingAlbums: true,
    doesSupportFetchingAlbumTracks: true,
    doesSupportAddingAlbums: true,
    doesSupportRemovingAlbums: true,
    doesSupportFetchingLibraryArtists: true,
    doesSupportFetchingArtists: true,
    doesSupportAddingArtistsToLibrary: true,
    doesSupportRemovingArtistsFromLibrary: true,
    doesSupportSearchByISRC: true,
    doesReturnISRC: false,
    doesReturnPreviewURL: true,
    doesReturnUserEmail: true,
    doesReturnUserCountry: true,
    maxLimit: 50,
  },
};
